"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMousePosition = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var use_raf_state_1 = require("./use-raf-state");

function useMousePosition(ref) {
  var _a = use_raf_state_1.useRafState({
    docX: 0,
    docY: 0,
    posX: 0,
    posY: 0,
    elX: 0,
    elY: 0,
    elH: 0,
    elW: 0
  }),
      state = _a[0],
      setState = _a[1];

  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var onMouseMove_1 = function onMouseMove_1(event) {
        if (!!ref.current) {
          var _a = ref.current.getBoundingClientRect(),
              left = _a.left,
              top_1 = _a.top,
              elW = _a.width,
              elH = _a.height;

          var posX = left + window.pageXOffset;
          var posY = top_1 + window.pageYOffset;
          var elX = event.pageX - posX;
          var elY = event.pageY - posY;
          setState({
            docX: event.pageX,
            docY: event.pageY,
            posX: posX,
            posY: posY,
            elX: elX,
            elY: elY,
            elH: elH,
            elW: elW
          });
        }
      };

      document.addEventListener('mousemove', onMouseMove_1);
      return function cleanup() {
        document.removeEventListener('mousemove', onMouseMove_1);
      };
    }
  }, [ref]);
  return state;
}

exports.useMousePosition = useMousePosition;